<template>

    <div class="alert-container">
        <div class="progress"></div>
        <v-alert class="mb-0" :message="alert.message" :type="alert.type" />
    </div>

</template>

<style scoped lang="scss">

    .alert-container {
        border-radius: 5px;
        box-shadow: 0 10px 30px rgba(0,0,0,0.3);
        margin-bottom: 5px;
        overflow: hidden;
        position: relative;
        .progress {
            animation: progress 3s linear;
            background: rgba(0,0,0,0.2);
            top: 0;
            height: 2px;
            position: absolute;
            width: 0;
            z-index: 1;
        }
    }

    @keyframes progress {
        0%   { width: 0; }
        100% { width: 100%; }
    }

</style>

<script>

export default {

    props: {
        alert: {
            type: Object,
            required: true,
        },
    },

    created() {
        setTimeout(this.dismiss, 3000);
    },

    methods: {

        dismiss() {
            this.$store.commit('removeAlert', this.alert.key);
        },

    },

}

</script>
